export { IntentionCreationRewardScreen as default } from '@/src/features/intention/ui/screens/IntentionCreationRewardScreen/IntentionCreationRewardScreen'
